module.exports = __webpack_public_path__ + "static/media/team.f6c3055c.svg";